module.exports = __webpack_public_path__ + "media/images/shop/box_dimension-e8345ae438c3028ab597ccff971b1725.png";